import React from 'react';
import AgentSearchSelect from '../../../components/form/AgentSearchSelect';

function AgentFilterSelect({
  id = 'agent-filter',
  value,
  onChange,
  agents: _agents,
  loading: _loading,
  mode,
  disabled,
  showAllOption = mode === 'admin',
  layout = 'inline',
  label = 'Agente',
}) {
  return (
    <AgentSearchSelect
      id={id}
      value={value}
      onChange={onChange}
      mode={mode}
      showAllOption={showAllOption}
      layout={layout}
      label={label}
      disabled={disabled}
    />
  );
}

export default AgentFilterSelect;
